import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from '../Utils';


// Account
function pathAccounts(accountId=null) {
  if (accountId) {
      return `accounts/${accountId}`;
  } else {
      return `accounts`;
  }
}

export function createAccounts(successCallback, errorCallback, data) {
  postAuth({
    "path": pathAccounts(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchAccounts(successCallback, errorCallback, data, accountId) {
  patchAuth({
    "path": pathAccounts(accountId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteAccounts(successCallback, errorCallback, accountId) {
  deleteAuth({
    "path": pathAccounts(accountId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageAccounts(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-accounts`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathViewAccountDetailsShforms(accountId=null) {
  if (accountId) {
      return `view/account-details-shforms/${accountId}`;
  } else {
      return `view/account-details-shforms`;
  }
}

export function getViewAccountDetailsShforms(successCallback, errorCallback, accountId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewAccountDetailsShforms(accountId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// API Details
export function getViewApiDetailsShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/api-details-shforms`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postResetApiKey(successCallback, errorCallback) {
  postAuth({
    "path": `reset-api-key`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}



// Account Members
function pathAccountMembers(memberId=null) {
  if (memberId) {
      return `account-members/${memberId}`;
  } else {
      return `account-members`;
  }
}

export function createAccountMembers(successCallback, errorCallback, data) {
  postAuth({
    "path": pathAccountMembers(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchAccountMembers(successCallback, errorCallback, data, memberId) {
  patchAuth({
    "path": pathAccountMembers(memberId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteAccountMembers(successCallback, errorCallback, memberId) {
  deleteAuth({
    "path": pathAccountMembers(memberId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getViewManageAccountMembers(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-account-members`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}











